// @ts-nocheck
import React from "react";
import { useSelector } from "react-redux";
import ImageUploadFlow from "../ImageUploadFlow";

// This modal handles uploading and updating the profile picture for the user
interface ProfilePictureUploadModalProps {
  onClose?: (result?: any) => void;
}

const ProfilePictureUploadModal: React.FC<ProfilePictureUploadModalProps> = ({ onClose }) => {
  const user = useSelector((state) => state.user?.permissionDetails || {});

  const profileAsset = {
    id: user?.id || "profile-picture",
    name: "Profile Picture",
    imageUrl: user?.profilePictureUrl
  };

  return (
    <ImageUploadFlow
      asset={profileAsset}
      onClose={onClose}
      uploadTarget="profile"
      title="Update Profile Picture"
    />
  );
};

export default ProfilePictureUploadModal;
